import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import { useEventsSortable } from '../../../EventsListContext';

import useStyles from '../../style';

const SortableColumn: FC<ColumnProps> = ({ columnKey, className, field = '' }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { sort, setSort } = useEventsSortable();

  const getDirection = (): string => {
    if (field === sort?.field) {
      return sort?.direction === 'desc' ? 'asc' : 'desc';
    }

    return 'desc';
  };

  const handleSort = () => {
    const direction = getDirection();

    const value = {
      field,
      direction,
    };

    setSort(value);
  };

  return (
    <div
      className={classNames('hoverable-action', classes.whiteSpace, classes.sortable, className, {
        activeSort: sort?.field === field,
      })}
      onClick={handleSort}
    >
      <span>{t(columnKey)}</span>
      {sort?.field === field ? (
        <Icon
          icon={
            IconmoonFont[sort?.direction === 'desc' ? 'caretDownFilled-16' : 'caretUpFilled-16']
          }
        />
      ) : null}
    </div>
  );
};

export default SortableColumn;
